module.exports = __webpack_public_path__ + "img/mail.0d58d4ad.svg";